import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {
  ActionToastComponent,
  IActionToastPayload
} from '@shared/components/action-toast/action-toast.component';

// Gives the user enough time to react to the action.
const ACTION_TOAST_MIN_TIMEOUT = 7000;

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
  constructor(
    private toastr: ToastrService,
    private t: TranslateService
  ) {}

  success(text: string, config: Partial<IndividualConfig> = {}) {
    this.toastr.success(text, null, Object.assign({ timeOut: this.getTimeOut(text) }, config));
  }

  error(text: string, config: Partial<IndividualConfig> = {}) {
    this.toastr.error(text, null, Object.assign({ timeOut: this.getTimeOut(text) }, config));
  }

  warn(text: string, config: Partial<IndividualConfig> = {}) {
    this.toastr.warning(text, null, Object.assign({ timeOut: this.getTimeOut(text) }, config));
  }

  info(text: string, config: Partial<IndividualConfig> = {}) {
    this.toastr.info(text, null, Object.assign({ timeOut: this.getTimeOut(text) }, config));
  }

  /** Info toast with an action button, e.g. "Undo". Emits once when the action is clicked. */
  infoWithAction(
    text: string,
    actionLabel: string,
    config: Partial<IndividualConfig> = {}
  ): Observable<void> {
    const toast = this.toastr.info(
      text,
      null,
      Object.assign(
        {
          timeOut: Math.max(this.getTimeOut(text), ACTION_TOAST_MIN_TIMEOUT),
          toastComponent: ActionToastComponent,
          payload: { actionLabel } as IActionToastPayload,
          tapToDismiss: false
        },
        config
      )
    );
    return toast.onAction.pipe(
      take(1),
      map(() => undefined)
    );
  }

  defaultError() {
    this.error(this.t.instant('errorDefault'));
  }

  getTimeOut(text) {
    let timeOut = 2000;
    if (text.length > 50) {
      timeOut = text.length * 40;
    }

    return timeOut;
  }
}
